import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UsersGridService {
  [x: string]: any;

  constructor(private readonly http: HttpClient) { }
  
  public roles :any= [];

  private readonly getAllUsers = environment.main_url + environment.getAllUsers
  private readonly saveUser = environment.main_url + environment.saveUser
  private readonly updateUser = environment.main_url + environment.updateUser
  private readonly inactivate = environment.main_url + environment.inactivateUser
  private readonly resetmfa = environment.main_url + environment.resetmfa
  private readonly getLoggedInUsers = environment.main_url + environment.getLoggedInUser
  private readonly PracticeArea = environment.main_url + environment.getPracticeArea

  getUsersList(pageNumber:any,pageSize:any,payload:any){
    return this.http.post<any>(this.getAllUsers+"?pageNumber="+pageNumber+"&pageSize="+pageSize,payload)
  }

  addUser(user:any){
    return this.http.post<any>(this.saveUser,user)
  }
  editUser(user:any){
    return this.http.post<any>(this.updateUser,user)
  }

  getLoginUser(){
    return this.http.post<any>(this.getLoggedInUsers,{})
  }

  getPracticeArea(){
    return this.http.get<any>(this.PracticeArea)
  }
  inactivateUser(user:any){
    return this.http.post<any>(this.inactivate,user)
  }

  async getAllUserRoles(){
    this.http.post<any>(environment.main_url + environment.listSecurityRoles,{}).subscribe(res => {
      this.roles= res?.rows.map((item:any) => ({ key: item.description, value: item.code }));;  
      // return this.roles;
    })
  }
  
  resetUser(userId:any){
    return this.http.post<any>(this.resetmfa+"/"+userId,{})
  }
  

}
